import { NoDisplayType } from '../DisplayTypes';
import { NoInputType } from '../InputTypes';
import { makeOperator } from './Operator';
export const name = 'WorkflowActive';
export default makeOperator({
  displayType: NoDisplayType,
  inputType: NoInputType,
  name
});